<div
    [formGroup]="form"
    *ngIf="canChangeActive && opts?.length > 0"
>
    <label
        class="mr-3 mb-0"
        id="piLevelOpt"
        >{{ optsLabel?.label | translate }}</label
    >
    <div class="d-inline-block">
        <ng-select
            [options]="opts"
            [placeholder]="optsLabel?.placeholder"
            ariaLabelledBy="piLevelOpt"
            formControlName="item"
        ></ng-select>
    </div>
</div>
